import { mapActions, mapGetters } from 'vuex';
import { getDeepObjectValue } from '@/utils/shared';
import { dynamicParameter } from './service/mixin-service';
import defaults from './configs/defaults';

export default function (name, path, emptyValue) {
  const getPath = dynamicParameter(path);
  const getEmptyValue = dynamicParameter(emptyValue);

  return {
    inject: {
      _windowIdentifier: {
        default() {
          return undefined;
        }
      },
      $form: {
        default() {
          return undefined;
        }
      },
      $setValueAtTargetFieldPath: {
        default() {
          return undefined;
        }
      },
      _inMemoryStore: {
        default() {
          return undefined;
        }
      },
    },
    computed: {
      ...mapGetters('activeWindows', ['getWindowData']),

      [name]: {
        get() {
          let targetFieldPath = getPath(this);
          let inMemoryStore = this._inMemoryStore ?? (('inMemoryStore' in this) ? this.inMemoryStore : undefined);
          let currentProp = (targetFieldPath.startsWith('persistentData') || targetFieldPath.startsWith('transientData.persistentDataAtEntry') || targetFieldPath.startsWith('transientData.readOnly')) 
              ? inMemoryStore : this.getWindowData(this._windowIdentifier || this.windowIdentifier);

          currentProp = getDeepObjectValue(currentProp, targetFieldPath);

          return currentProp === undefined || currentProp === null
            ? getEmptyValue(this)
            : currentProp;
        },
        async set(newValue) {
          let targetFieldPath = getPath(this);
          let windowIdentifier = this._windowIdentifier || this.windowIdentifier;

          if(targetFieldPath.startsWith('persistentData') || targetFieldPath.startsWith('transientData.persistentDataAtEntry') || targetFieldPath.startsWith('transientData.readOnly')) {
            let setWindowData = this.$setValueAtTargetFieldPath !== undefined ? this.$setValueAtTargetFieldPath : this.setValueAtTargetFieldPath;
            setWindowData(targetFieldPath, newValue, windowIdentifier);
          }
          else {
            this.setWindowDataField({
              ...(windowIdentifier),
              targetFieldPath: targetFieldPath,
              value: newValue
            });
          }
        }
      }
    },
    methods: {
      ...mapActions('activeWindows', ['setWindowDataField'])
    },
    created() {
      if (!this._windowIdentifier && !this.windowIdentifier) 
        window.console.warn(`Injection of windowIdentifier failed for property ${name}.`);

      if (this.$form?.isNew && getPath(this)) {
        let currentVal = this[name];
        if (currentVal !== undefined && currentVal !== null)
          return;

        const defaultValue = getEmptyValue(this) ?? defaults[this._windowIdentifier?.type]?.[getPath(this)];

        if (defaultValue === undefined)
          return;

        this[name] = defaultValue;
      }
    }
  }
}
